import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import RootReducer from "./Reducers/root.reducers";

const store = createStore(RootReducer, applyMiddleware(thunk));

store.subscribe(() => {});
export default store;
